var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',{staticClass:"view-feature-announcements"},_vm._l((_vm.relevantAnnouncements),function(announcement){return _c('ChalkyUiCoachMarkSequencer',{key:announcement.id,staticClass:"newfeature-coach-marks",attrs:{"id":announcement.id,"steps":announcement.steps}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }